import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

import CreateClubModal from "./CreateClubModal";

const CreateClubModalContext = createContext(null);

export function useCreateClubModal() {
  const ctx = useContext(CreateClubModalContext);
  if (!ctx) {
    throw new Error("useCreateClubModal must be used within CreateClubModalProvider");
  }
  return ctx;
}

/**
 * Mounts {@link CreateClubModal} once at the app root (inside Router).
 * Call `openCreateClubModal()` from any entry point to open the flow without navigating.
 */
export function CreateClubModalProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openCreateClubModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closeCreateClubModal = useCallback(() => {
    setOpen(false);
  }, []);

  const value = useMemo(
    () => ({ openCreateClubModal, closeCreateClubModal }),
    [openCreateClubModal, closeCreateClubModal]
  );

  return (
    <CreateClubModalContext.Provider value={value}>
      {children}
      <CreateClubModal isOpen={open} onClose={closeCreateClubModal} />
    </CreateClubModalContext.Provider>
  );
}
